// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminCegadatApiController from "./admin_cegadat_api_controller"
application.register("admin-cegadat-api", AdminCegadatApiController)

import AdminSubscriberContractController from "./admin_subscriber_contract_controller"
application.register("admin-subscriber-contract", AdminSubscriberContractController)

import AiChartsController from "./ai_charts_controller"
application.register("ai-charts", AiChartsController)

import AiController from "./ai_controller"
application.register("ai", AiController)

import AiStatsController from "./ai_stats_controller"
application.register("ai-stats", AiStatsController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import AreaCodeController from "./area_code_controller"
application.register("area-code", AreaCodeController)

import AssociateModalController from "./associate_modal_controller"
application.register("associate-modal", AssociateModalController)

import AttachChildController from "./attach_child_controller"
application.register("attach-child", AttachChildController)

import AuditEventsFilterController from "./audit_events_filter_controller"
application.register("audit-events-filter", AuditEventsFilterController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import AutogrowController from "./autogrow_controller"
application.register("autogrow", AutogrowController)

import AvatarController from "./avatar_controller"
application.register("avatar", AvatarController)

import AvatarPickerController from "./avatar_picker_controller"
application.register("avatar-picker", AvatarPickerController)

import BeaconController from "./beacon_controller"
application.register("beacon", BeaconController)

import BillingPricingModelController from "./billing_pricing_model_controller"
application.register("billing-pricing-model", BillingPricingModelController)

import BillingQuantitySelectableController from "./billing_quantity_selectable_controller"
application.register("billing-quantity-selectable", BillingQuantitySelectableController)

import BootstrapTooltipsController from "./bootstrap_tooltips_controller"
application.register("bootstrap-tooltips", BootstrapTooltipsController)

import BsController from "./bs_controller"
application.register("bs", BsController)

import BuildingComplexPrefixController from "./building_complex_prefix_controller"
application.register("building-complex-prefix", BuildingComplexPrefixController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import ChatDockReactWrapController from "./chat_dock_react_wrap_controller"
application.register("chat-dock-react-wrap", ChatDockReactWrapController)

import ChatReactWrapController from "./chat_react_wrap_controller"
application.register("chat-react-wrap", ChatReactWrapController)

import ChatStatsChartsController from "./chat_stats_charts_controller"
application.register("chat-stats-charts", ChatStatsChartsController)

import ClickableLinkController from "./clickable_link_controller"
application.register("clickable-link", ClickableLinkController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CallCenterWidgetController from "./call_center_widget_controller"
application.register("call-center-widget", CallCenterWidgetController)

import WidgetManagerController from "./widget_manager_controller"
application.register("widget-manager", WidgetManagerController)

import CallCenterPhoneController from "./call_center_phone_controller"
application.register("call-center-phone", CallCenterPhoneController)

import PasswordRevealController from "./password_reveal_controller"
application.register("password-reveal", PasswordRevealController)


import CallCenterChartsController from "./call_center_charts_controller"
application.register("call-center-charts", CallCenterChartsController)

import CompanyActivitiesController from "./company_activities_controller"
application.register("company-activities", CompanyActivitiesController)

import CompanyCegadatApiController from "./company_cegadat_api_controller"
application.register("company-cegadat-api", CompanyCegadatApiController)

import CompanyTasksFilterController from "./company_tasks_filter_controller"
application.register("company-tasks-filter", CompanyTasksFilterController)

import CoordinatesMapController from "./coordinates_map_controller"
application.register("coordinates-map", CoordinatesMapController)

import DashboardChartsController from "./dashboard_charts_controller"
application.register("dashboard-charts", DashboardChartsController)

import AdminLiveOpsController from "./admin_live_ops_controller"
application.register("admin-live-ops", AdminLiveOpsController)

import DocEditorController from "./doc_editor_controller"
application.register("doc-editor", DocEditorController)

import DragController from "./drag_controller"
application.register("drag", DragController)

import EditorController from "./editor_controller"
application.register("editor", EditorController)

import EditorjsController from "./editorjs_controller"
application.register("editorjs", EditorjsController)

import EhazHouseSelectionController from "./ehaz_house_selection_controller"
application.register("ehaz-house-selection", EhazHouseSelectionController)

import EhazSyncController from "./ehaz_sync_controller"
application.register("ehaz-sync", EhazSyncController)

import EhazUnlinkController from "./ehaz_unlink_controller"
application.register("ehaz-unlink", EhazUnlinkController)

import EmailController from "./email_controller"
application.register("email", EmailController)

import EmailStatsChartController from "./email_stats_chart_controller"
application.register("email-stats-chart", EmailStatsChartController)

import EmailStatsChartsController from "./email_stats_charts_controller"
application.register("email-stats-charts", EmailStatsChartsController)

import ReportsChartsController from "./reports_charts_controller"
application.register("reports-charts", ReportsChartsController)

import EmailComplianceChartsController from "./email_compliance_charts_controller"
application.register("email-compliance-charts", EmailComplianceChartsController)

import EquipmentCascadingSelectController from "./equipment_cascading_select_controller"
application.register("equipment-cascading-select", EquipmentCascadingSelectController)

import FileGroupController from "./file_group_controller"
application.register("file-group", FileGroupController)

import FileAttachmentTagPickerController from "./file_attachment_tag_picker_controller"
application.register("file-attachment-tag-picker", FileAttachmentTagPickerController)

import FileTagPreviewController from "./file_tag_preview_controller"
application.register("file-tag-preview", FileTagPreviewController)

import FilePreviewController from "./file_preview_controller"
application.register("file-preview", FilePreviewController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FocusOnController from "./focus_on_controller"
application.register("focus-on", FocusOnController)

import GlobalsearchController from "./globalsearch_controller"
application.register("globalsearch", GlobalsearchController)

import GuideSiteBuildPollerController from "./guide_site_build_poller_controller"
application.register("guide-site-build-poller", GuideSiteBuildPollerController)

import HashTabController from "./hash_tab_controller"
application.register("hash-tab", HashTabController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImportController from "./import_controller"
application.register("import", ImportController)

import ImportCableStartController from "./import_cable_start_controller"
application.register("import-cable-start", ImportCableStartController)

import ImapImportPortController from "./imap_import_port_controller"
application.register("imap-import-port", ImapImportPortController)

import ImportMappingController from "./import_mapping_controller"
application.register("import-mapping", ImportMappingController)

import LayoutController from "./layout_controller"
application.register("layout", LayoutController)

import LazyHighlightController from "./lazy_highlight_controller"
application.register("lazy-highlight", LazyHighlightController)

import LoadingBarController from "./loading_bar_controller"
application.register("loading-bar", LoadingBarController)

import LottieFilesController from "./lottie_files_controller"
application.register("lottie-files", LottieFilesController)

import MainmenuController from "./mainmenu_controller"
application.register("mainmenu", MainmenuController)

import MailboxVerifyController from "./mailbox_verify_controller"
application.register("mailbox-verify", MailboxVerifyController)

import MailboxWizardController from "./mailbox_wizard_controller"
application.register("mailbox-wizard", MailboxWizardController)

import MarkdownController from "./markdown_controller"
application.register("markdown", MarkdownController)

import MediaCaptureController from "./media_capture_controller"
application.register("media-capture", MediaCaptureController)

import MentionsController from "./mentions_controller"
application.register("mentions", MentionsController)

import MessengerChartsController from "./messenger_charts_controller"
application.register("messenger-charts", MessengerChartsController)

import MiniChartsController from "./mini_charts_controller"
application.register("mini-charts", MiniChartsController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavTabsController from "./nav_tabs_controller"
application.register("nav-tabs", NavTabsController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import PackageDeliveryAutocompleteController from "./package_delivery_autocomplete_controller"
application.register("package-delivery-autocomplete", PackageDeliveryAutocompleteController)

import PackageRecipientAutocompleteController from "./package_recipient_autocomplete_controller"
application.register("package-recipient-autocomplete", PackageRecipientAutocompleteController)

import PackageStatsController from "./package_stats_controller"
application.register("package-stats", PackageStatsController)

import PatrolController from "./patrol_controller"
application.register("patrol", PatrolController)

import PatrolFilePreviewController from "./patrol_file_preview_controller"
application.register("patrol-file-preview", PatrolFilePreviewController)

import PeopleController from "./people_controller"
application.register("people", PeopleController)

import PersonGroupController from "./person_group_controller"
application.register("person-group", PersonGroupController)

import PersonalMailboxFormController from "./personal_mailbox_form_controller"
application.register("personal-mailbox-form", PersonalMailboxFormController)

import PhotoswipeController from "./photoswipe_controller"
application.register("photoswipe", PhotoswipeController)

import PickupModalController from "./pickup_modal_controller"
application.register("pickup-modal", PickupModalController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import PostcodeController from "./postcode_controller"
application.register("postcode", PostcodeController)

import PropertyManagerBreadcrumbsController from "./property_manager_breadcrumbs_controller"
application.register("property-manager-breadcrumbs", PropertyManagerBreadcrumbsController)

import PropertyManagerController from "./property_manager_controller"
application.register("property-manager", PropertyManagerController)

import PulltorefreshController from "./pulltorefresh_controller"
application.register("pulltorefresh", PulltorefreshController)

import QuoteRequestController from "./quote_request_controller"
application.register("quote-request", QuoteRequestController)

import QuoteSubmissionController from "./quote_submission_controller"
application.register("quote-submission", QuoteSubmissionController)

import RefreshController from "./refresh_controller"
application.register("refresh", RefreshController)

import ReportTaskWorkflowController from "./report_task_workflow_controller"
application.register("report-task-workflow", ReportTaskWorkflowController)

import ResidentReportBreadcrumbsController from "./resident-report-breadcrumbs_controller"
application.register("resident-report-breadcrumbs", ResidentReportBreadcrumbsController)

import ResidentReportController from "./resident_report_controller"
application.register("resident-report", ResidentReportController)

import SearchResultsController from "./search_results_controller"
application.register("search-results", SearchResultsController)

import SearchScopeDropdownController from "./search_scope_dropdown_controller"
application.register("search-scope-dropdown", SearchScopeDropdownController)

import SecurityServicesPatrolsRoadController from "./security_services_patrols_road_controller"
application.register("security-services-patrols-road", SecurityServicesPatrolsRoadController)

import ServiceProviderLogController from "./service_provider_log_controller"
application.register("service-provider-log", ServiceProviderLogController)

import ShowMoreController from "./show_more_controller"
application.register("show-more", ShowMoreController)

import SubscriptionChartsController from "./subscription_charts_controller"
application.register("subscription-charts", SubscriptionChartsController)

import SubscriptionCatalogController from "./subscription_catalog_controller"
application.register("subscription-catalog", SubscriptionCatalogController)

import QuotaMetersController from "./quota_meters_controller"
application.register("quota-meters", QuotaMetersController)

import SupportLayoutController from "./support_layout_controller"
application.register("support-layout", SupportLayoutController)

import SupportReplyController from "./support_reply_controller"
application.register("support-reply", SupportReplyController)

import TableController from "./table_controller"
application.register("table", TableController)

import TaskBreadcrumbsController from "./task_breadcrumbs_controller"
application.register("task-breadcrumbs", TaskBreadcrumbsController)

import TaskCalendarVisibilityController from "./task_calendar_visibility_controller"
application.register("task-calendar-visibility", TaskCalendarVisibilityController)

import TaskController from "./task_controller"
application.register("task", TaskController)

import TaskFormController from "./task_form_controller"
application.register("task-form", TaskFormController)

import TaskApprovalController from "./task_approval_controller"
application.register("task-approval", TaskApprovalController)

import TaskKanbanController from "./task_kanban_controller"
application.register("task-kanban", TaskKanbanController)

import TaskModalController from "./task_modal_controller"
application.register("task-modal", TaskModalController)

import TaskPeopleController from "./task_people_controller"
application.register("task-people", TaskPeopleController)

import TaskPersonGroupsController from "./task_person_groups_controller"
application.register("task-person-groups", TaskPersonGroupsController)

import TaskScheduleController from "./task_schedule_controller"
application.register("task-schedule", TaskScheduleController)

import TaskTagController from "./task_tag_controller"
application.register("task-tag", TaskTagController)

import TaskV2BcPickerController from "./task_v2_bc_picker_controller"
application.register("task-v2-bc-picker", TaskV2BcPickerController)

import TechnicalSpecsController from "./technical_specs_controller"
application.register("technical-specs", TechnicalSpecsController)

import TextHighlightController from "./text_highlight_controller"
application.register("text-highlight", TextHighlightController)

import TimelineController from "./timeline_controller"
application.register("timeline", TimelineController)

import TiptapController from "./tiptap_controller"
application.register("tiptap", TiptapController)

import VoiceAssistantChartsController from "./voice_assistant_charts_controller"
application.register("voice-assistant-charts", VoiceAssistantChartsController)

import VoiceAssistantNavController from "./voice_assistant_nav_controller"
application.register("voice-assistant-nav", VoiceAssistantNavController)

import VoiceChartsController from "./voice_charts_controller"
application.register("voice-charts", VoiceChartsController)

import VoiceDictateController from "./voice_dictate_controller"
application.register("voice-dictate", VoiceDictateController)

import WebdavStatsChartsController from "./webdav_stats_charts_controller"
application.register("webdav-stats-charts", WebdavStatsChartsController)

import WebpushController from "./webpush_controller"
application.register("webpush", WebpushController)

import WorkflowController from "./workflow_controller"
application.register("workflow", WorkflowController)

import WorkflowRunDetailPollerController from "./workflow_run_detail_poller_controller"
application.register("workflow-run-detail-poller", WorkflowRunDetailPollerController)

import WorkflowRunsPollerController from "./workflow_runs_poller_controller"
application.register("workflow-runs-poller", WorkflowRunsPollerController)

import IvrFlowDesignerController from "./ivr_flow_designer_controller"
application.register("ivr-flow-designer", IvrFlowDesignerController)

import IvrVoicePreviewController from "./ivr_voice_preview_controller"
application.register("ivr-voice-preview", IvrVoicePreviewController)
